const seo = {
  home: {
    title: "Shorten, Track, and Manage Your Links Easily",
    description:
      "Shodl is a fast, powerful, and reliable URL shortener with numerous exceptional features. Create shortened links using smart, custom, or random codes. Secure your URLs with passcode protection, set maximum redirect limits, and choose flexible expiration rules — including permanent or time-based options. Easily manage and track all your shortenings in one place with detailed insights and filtering tools.",
  },
  shorten: {
    title: "Shorten Link",
    description:
      "Shorten your links in seconds. Use smart, custom, or random codes as slugs in your shortened URLs. Protect your links with a passcode, limit the maximum number of redirects, set desired expiration rules, and manage the revealable option to hide or reveal the source link after expiration.",
  },
  login: {
    title: "Login",
    description:
      "Securely log in to your Shodl account to manage and track your shortened links.",
  },
  signup: {
    title: "Create Your Account",
    description:
      "Sign up for a free Shodl account to manage your shortened links, view analytics, and unlock powerful features like custom codes, passcode protection, and expiration settings.",
  },
  privacy: {
    title: "Privacy Policy",
    description:
      "Learn how Shodl collects, uses, and protects your personal data. Your privacy is important to us. Read our full privacy policy here.",
  },
  terms: {
    title: "Terms and Conditions",
    description:
      "Review the terms and conditions for using Shodl's URL shortening service. Understand your rights and responsibilities when using our platform.",
  },
  resetPassword: {
    title: "Reset Your Password",
    description:
      "Forgot your password? Reset your Shodl account password securely using your registered email address.",
  },
  reset: {
    title: "Set Your New Password",
    description:
      "Change your Shodl account password securely. After submitting your new password, the current link deactivates automatically.",
  },
  dashboard: {
    title: "Dashboard",
    description:
      "Manage and track all your shortened URLs with the Shodl Dashboard. Search conversions by source or destination links, sort by key parameters, and filter.",
  },
  conversionView: {
    title: "Conversion View",
    description:
      "Explore detailed information about your shortened links: track redirects, view usage stats, and manage passcodes, limits, and other options.",
  },
  settings: {
    title: "Settings",
    description:
      "Customize your Shodl account settings. Manage preferences, view your usage statistics, monitor domains of shortened links, and contact support if needed.",
  },
  redirects: {
    title: "Redirects",
    description:
      "View all redirects that occurred on your links in one place. Monitor the exact date, time, and other metadata for each redirect.",
  },
  redirect: {
    title: "Shortened Link",
    description:
      "This link will redirect you to the destination URL. After clicking, please wait while we securely process the shortened URL.",
  },
  confirmAccount: {
    title: "Confirm Your Account",
    description:
      "Confirm your Shodl account by clicking the link in the email. Your email address will be used to contact you in case of any issues.",
  },
  notFound: {
    title: "Page Not Found",
    description:
      "The page you’re looking for doesn’t exist or may have been moved. Check the URL or return to the Shodl homepage.",
  },
  checkSubmit: {
    title: "Submit Link Check",
    description:
      "Check your Shodl link in case you are unsure where it redirects. See if the owner of the link is willing to reveal the source.",
  },
  check: {
    title: "Check Link",
    description:
      "Check your Shodl link code for the source URL. See whether a Shodl link with such code is revealable or not.",
  },
  tags: {
    title: "Tags",
    description:
      "Manage all your tags in one place. See how many conversions each tag has.",
  },
};

export default seo;
